import { useOktaAuth } from '@okta/okta-react';
import { Space } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import {
  ProductiveHeading03,
  ProductiveHeading04,
  ProductiveHeading05,
} from 'components/styles';
import { RoutePaths } from 'constant';
import { useAccountMetaQuery } from 'queries';
import { CompanyLogo } from './common';

const Container = styled.div`
  padding: var(--spacing-12);
  text-align: center;
  display: flex;
  width: 100%;
  min-width: 420px;
  justify-content: center;
`;

const Heading = styled.div`
  ${ProductiveHeading04};
`;

const Strong = styled.strong`
  font-weight: var(--font-weight-bold);
  padding-left: var(--spacing-03);
`;

const Message = styled.div`
  ${ProductiveHeading03};
`;
const Greeting = styled.div`
  ${ProductiveHeading05};
`;

export const GoodbyePage: FC = () => {
  const [timeLeft, setTimeLeft] = useState(10);
  const { authState } = useOktaAuth();
  const { data, isLoading } = useAccountMetaQuery();
  const { push, replace } = useHistory();

  const isAuthenticated = authState?.isAuthenticated;

  useEffect(() => {
    if (isAuthenticated) {
      replace(RoutePaths.logout);
    }
  }, [isAuthenticated, replace]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1);
      } else if (timeLeft === 0) {
        clearInterval(interval);
        push(RoutePaths.login);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, push]);

  return isLoading ? (
    <PageLoading />
  ) : (
    <Container>
      <Space size={80} direction="vertical">
        <Space size={48} direction="vertical">
          <Space size={96} direction="vertical">
            <Space size={24}>
              {data && <CompanyLogo data={data.company} />}
              <Heading>
                {data?.company.companyName}
                <Strong>
                  <FormattedMessage id="onboarding" />
                </Strong>
              </Heading>
            </Space>
            <Message>
              <FormattedMessage id="goodbye.logged_out" />
            </Message>
          </Space>
          <Greeting>
            <FormattedMessage id="goodbye.great_day" />
          </Greeting>
        </Space>
        <Space direction="vertical" size={12}>
          <div>
            <FormattedMessage id="goodbye.redirect" values={{ timeLeft }} />
          </div>
          <div>
            <Link to={RoutePaths.login}>
              <FormattedMessage id="goodbye.return_login" />
            </Link>
          </div>
        </Space>
      </Space>
    </Container>
  );
};
